"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureGraphTooltip = void 0;
var chart_js_1 = require("chart.js");
var graphPositioners_1 = require("./graphPositioners");
var createElement = function (tagName, attributes, styles) {
    if (attributes === void 0) { attributes = {}; }
    if (styles === void 0) { styles = {}; }
    var element = document.createElement(tagName);
    Object.keys(attributes).forEach(function (key) { return element.setAttribute(key, attributes[key]); });
    Object.keys(styles).forEach(function (key) { return element.style[key] = styles[key]; });
    return element;
};
/**
 * This function is used to set the contents of the tooltip in the chart based on its data.
 */
var configureGraphTooltip = function (context) {
    var chart = context.chart, tooltip = context.tooltip;
    var tooltipEl = chart.canvas.parentNode.querySelector('.ui-chart-tooltip');
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = '0';
        return;
    }
    if (tooltip.dataPoints.length > 0) {
        var titleLines = tooltip.title || [];
        // add title
        tooltipEl.querySelector('.ui-chart-tooltip-title').innerHTML = titleLines.join('<br>');
        // add table with data
        tooltipEl.querySelector('tbody').innerHTML = '';
        tooltip.dataPoints.forEach(function (dataPoint, i) {
            var colors = tooltip.labelColors[i];
            var span = createElement('span', {
                class: 'ui-chart-tooltip-color',
            }, {
                background: colors.backgroundColor,
                borderColor: colors.borderColor,
            });
            var tr = createElement('tr');
            var td1 = createElement('td');
            var td2 = createElement('td');
            td1.innerText = dataPoint.dataset.label;
            td2.innerText = String(dataPoint.raw) + (dataPoint.dataset.unit || '');
            td1.prepend(span);
            tr.appendChild(td1);
            tr.appendChild(td2);
            tooltipEl.querySelector('tbody').appendChild(tr);
        });
    }
    // display the tooltip
    var _a = chart.canvas, positionX = _a.offsetLeft, positionY = _a.offsetTop;
    tooltipEl.style.opacity = '1';
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
};
exports.configureGraphTooltip = configureGraphTooltip;
// Create a custom tooltip positioner to place the toolip at the right or left of the chart area
chart_js_1.Tooltip.positioners['custom'] = graphPositioners_1.externalTooltipPositioner;
